import axios from 'axios';

export const API = axios.create({baseURL: process.env.REACT_APP_API_URL, withCredentials: true});

// Auth
export const signUp = (data) => API.post("/signup", data);
export const signIn = (data) => API.post("/signin", data);
export const checkAuthentication = () => API.get("/checkAuth");
export const logoutUser = () => API.post("/logout");
export const forgotPassword = (data) => API.post("/forgot-password", data);
export const resetPassword = (data) => API.post("/reset-password", data);

//Posts
export const createPost = (newPost) => API.post(`/posts`, newPost);
export const updatePost = (formData) => API.patch(`/posts`, formData);
export const deletePost = (id) => API.delete(`/posts/${id}`);
export const likePost = (id) => API.get(`/posts/like/${id}`);
export const savePost = (id) => API.get(`/posts/save/${id}`);
export const checkPostLike = (id) => API.get(`/posts/liked/${id}`);
export const checkPostSave = (id) => API.get(`/posts/saved/${id}`);
export const getSavedPosts = () => API.post('/posts/saved_posts');
export const getLikeNumber = (id) => API.get(`/posts/like_count/${id}`);
export const user_posts = (id) => API.get(`/posts/user_posts/${id}`);

//Comments for posts
export const createComment = (newComment) => API.post(`/comments`, newComment);
export const likeComment = (id) => API.post(`/comments/like/${id}`);
export const getCommentLike_number = (id) => API.get(`/comments/like_count/${id}`);
export const getPostComment = (id) => API.get(`/comments/getPostComment/${id}`);
export const getCommentNumber = (id) => API.get(`/comments/comment_number/${id}`);
export const delete_comment = (id) => API.get(`/comments/delete_comment/${id}`);

//Replies
export const createReply = (newReply) => API.post('/replies', newReply);
export const getPostReplies = (id) => API.get(`/replies/${id}`);
export const getReplyNumber = (id) => API.get(`/replies/reply_count/${id}`);
export const delete_reply = (id) => API.get(`/replies/delete_reply/${id}`);

//Users
export const userProfileInfo = (id) => API.get(`/user/${id}`);
export const userImageProfile = (data) => API.post('/userImageProfile/edit', data);
export const userCoverProfile = (data) => API.post('/userCoverProfile/edit', data);
export const authInfo = () => API.post('/user/auth');
export const userSearch = (data) => API.post(`/user/search?search=${data}`);

//Followers
export const addFollower = (id) => API.get(`/follow/addFollower/${id}`);
export const deleteFollower = (id) => API.get(`/follow/unfollow/${id}`);
export const getFollowers = () => API.post('/follow/getFollowers');
export const getFollowing = () => API.post('/follow/getFollowing');
export const check_followship = (id) => API.get(`/follow/check_followship/${id}`);

//Notifications
export const getNotifications = () => API.post('/notifications');
export const readNotifications = (id) => API.get(`/notifications/read/${id}`)